const managementPostingsFiltersTemplate = {
  jobTitle: "",
  skills: [],
  industries: [],
  contractors: [],
  countries: [],
  states: [],
  cities: [],
  managers: [],
  postedAt: "",
  minDuration: "",
  maxDuration: "",
};

export default managementPostingsFiltersTemplate;